const ExpandToggleButton = ({
  toggleDisplay,
  isExpanded,
}: {
  toggleDisplay: () => void;
  isExpanded: boolean;
}) => {
  return (
    <div>
      {" "}
      <div className="flex items-center">
        <span className="mr-2 text-gray-700">펼쳐보기</span>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only"
            checked={isExpanded}
            onChange={toggleDisplay}
          />
          <div
            className={`w-11 h-6 rounded-full shadow-inner ${
              isExpanded ? "bg-blue-500" : "bg-gray-300"
            }`}
          ></div>
          <div
            className={`absolute w-6 h-6 bg-white rounded-full shadow transform transition-transform duration-300 ease-in-out ${
              isExpanded ? "translate-x-5" : "translate-x-0"
            }`}
          ></div>
        </label>
      </div>
    </div>
  );
};

export default ExpandToggleButton;
